import { render, staticRenderFns } from "./ModalProcedimentoCompartilhadoIncluir.vue?vue&type=template&id=512f810e&scoped=true"
import script from "./ModalProcedimentoCompartilhadoIncluir.vue?vue&type=script&lang=ts"
export * from "./ModalProcedimentoCompartilhadoIncluir.vue?vue&type=script&lang=ts"
import style0 from "./ModalProcedimentoCompartilhadoIncluir.vue?vue&type=style&index=0&id=512f810e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f810e",
  null
  
)

export default component.exports